var block_mediaText = {
	
	ui: {},

	init: function() {
		this.bindUI();
		this.bindEvents();

        this.initSlider();
	},

	bindUI: function() {
		this.ui.$slider = $('.js-mediaText-slider');
	},

	bindEvents: function() {
		// this.ui.$slick.on('ready', this.mediaToCarousel.bind(this));
	},

	initSlider: function() {
		this.ui.$slider.slick({
			centerMode: false,
            dots: false,

            slidesToShow: 1,
            slideToScroll: 1,
			prevArrow: '<button type="button" class="slick-prev" style="display:none;"></button>',
			nextArrow: '<button type="button" class="slick-next button-chevron button-chevron--small"><svg class="icon icon-caret" aria-hidden="true"><use xlink:href="#icon-caret" /></svg></button>'
		});

		
	},

};

module.exports = block_mediaText;
